import client from "../Client/HttpClient";
import {IJourneysModel} from "@/interfaces/modules";
const ApiPath = "Journeys";

export default {
    GetJourneys:(): Promise <IJourneysModel[]> => client.get(`${ApiPath}`),
    GetJourneysById: (data: IJourneysModel ):Promise<IJourneysModel>=>client.get(`${ApiPath}/${data.Id}`),
    PostJourney : (data:IJourneysModel ) : Promise<IJourneysModel>=>client.post(`${ApiPath}`, data),
  };